import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { savingNodesPositions } from '../actions/scrolling';
import Weather from '../components/Weather';
import AboutLeQG from '../components/leqg/AboutLeQG';
import Gallery from '../components/Gallery';
import Header from '../components/Header';
import Footer from '../components/Footer';
import NavigationBar from '../components/NavigationBar';
import Contact from '../components/Contact';
import Events from '../components/Events';
import Menu from '../components/Menu';
import { getMenuBySlug } from '../actions/MenusAction';
import { getEventsBySlug } from '../actions/EventsAction';
import { getGallery } from '../actions/GallerieAction';
import HeaderWithBooking from '../components/leqg/HeaderWithBooking';
import Icon from '../assets/images/logo/leqg-logo.svg';

class LeQG extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: 0,
      items: [],
      images: [],
    };
  }

  componentDidMount() {
    this.props.getGallery('leqgsousse');
    this.props.getEventsBySlug('leqgsousse');

    this.props.getMenuBySlug('leqgsousse');
    const about = ReactDOM.findDOMNode(this.refs.about);
    const events = ReactDOM.findDOMNode(this.refs.events);
    const menu = ReactDOM.findDOMNode(this.refs.menu);
    const weather = ReactDOM.findDOMNode(this.refs.weather);
    const gallery = ReactDOM.findDOMNode(this.refs.gallery);

    this.props.savingNodesPositions({
      leqg: {
        about: about.offsetTop,
        events: events.offsetTop,
        menu: menu.offsetTop,
        weather: weather.offsetTop,
        gallery: gallery.offsetTop,
      },
    });
  }

  render() {
    return (
      <Fragment>
        <Header
          content={
            <HeaderWithBooking
              icon={<img alt="Logo" className="m-2" src={Icon} style={{ height: 250 }} />}
              eventsBooking={this.props.events}
            />
          }
          background="leqg-header-bg"
        >
          <NavigationBar
            slug="leqg"
            navigations={[
              { name: 'about', txt: 'About' },
              { name: 'events', txt: 'Events' },
              { name: 'menu', txt: 'Menu' },
              { name: 'weather', txt: 'Météo' },
              { name: 'gallery', txt: 'Gallery' },
            ]}
          />
        </Header>
        <AboutLeQG ref="about" background="leqg-about-bg" />
        <Events ref="events" background="leqg-event-bg" showPlace data={this.props.events} />
        <Menu ref="menu" background="leqg-menu-bg" color="blue" data={this.props.menus} />
        <Weather ref="weather" background="leqg-weather-bg" />
        <Gallery ref="gallery" background="leqg-gallery-bg" medias={this.props.gallerie} />
        <Contact ref="contact" minimal color="#016fc5" placeholders="#39a3fe" background="leqg-about-bg" info={info} />
        <Footer color="#016fc5" secondColor="#39a3fe" />
      </Fragment>
    );
  }
}

const info = {
  facebook: 'https://www.facebook.com/leqgsousse/',
  insta: 'https://www.instagram.com/explore/locations/547878854/le-qg/',
  youtube: '',
  tripAdvisor:
    'https://www.tripadvisor.fr/Restaurant_Review-g1189197-d7686268-Reviews-Le_Qg-Hammam_Sousse_Sousse_Governorate.html',
  address: (
    <span>
      Golf Advanced Services, Port El Kantaoui,Hammam Sousse,4089 <br />
      Siége social : A 6-4,Immeuble Venus, centre Urbain Nord, 1003 Tunis.
    </span>
  ),
};

export default connect(
  store => ({
    scrolling: store.scrolling,
    menus: store.menus,
    gallerie: store.gallerie,
    events: store.events,
  }),
  {
    savingNodesPositions,
    getMenuBySlug,
    getEventsBySlug,
    getGallery,
  }
)(LeQG);



// WEBPACK FOOTER //
// ./src/pages/leqg.jsx